import Box from '@mui/material/Box';
import { memo } from 'react';
import { TwitchChat } from 'react-twitch-embed';
import { toTwitchChannel } from 'src/util/toTwitchChannel';

export type TwitchChatBluMintProps = {
  activeMediaUrl: string;
};

// This is necessary to prevent the chat from re-rendering when the user scrolls
export const TwitchChatBluMint = memo(function TwitchChatBluMint({
  activeMediaUrl,
}: TwitchChatBluMintProps) {
  return (
    <Box sx={{ height: '100%' }}>
      <TwitchChat
        channel={toTwitchChannel('https://www.twitch.tv/', activeMediaUrl)}
        height="100%"
        width="100%"
      />
    </Box>
  );
});
